import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { LAST_MONTH_RENT } from '../../../constants';
import { FEE_PAYMENT_TIME } from '../../../constants/stringConstants';
import FeePaymentTime from '../../Widgets/FeePaymentTime';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function LastMonthRent_v2({ section, setSectionValues }: Props) {
  function onNoLastMonth() {
    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesLastMonth() {
    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onPayDueClick(event: any): void {
    const { id } = event.currentTarget;

    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.UPON_SIGNING]: id === FEE_PAYMENT_TIME.FIRST_PAY_ON_SIGN,
      [LAST_MONTH_RENT.FIELD_NAME.START_MOVE_IN_DATE]: id === FEE_PAYMENT_TIME.FIRST_PAY_ON_LEASE_START,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Will you collect the last month’s rent payment upfront?</Label>}
      disabled={section.isFieldDisabled(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
      control={
        <YesAndNoExpansion
          yesHandler={onYesLastMonth}
          noHandler={onNoLastMonth}
          yesActive={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
          disabled={section.isFieldDisabled(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
        >
          <FeePaymentTime
            label="When is last month rent due?"
            section={section}
            onChange={onPayDueClick}
            firstChecked={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.UPON_SIGNING)}
            secondChecked={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.START_MOVE_IN_DATE)}
            firstField={LAST_MONTH_RENT.FIELD_NAME.UPON_SIGNING}
            secondField={LAST_MONTH_RENT.FIELD_NAME.START_MOVE_IN_DATE}
          />
        </YesAndNoExpansion>
      }
    />
  );
}

LastMonthRent_v2.description = 'Payment timing added';

export default LastMonthRent_v2;
